<template>
  <v-dialog
    persistent
    v-model="isOpen"
    max-width="95vw"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
    @keydown.left="imagenAnterior"
    @keydown.right="imagenSiguiente"
  >
    <v-card class="elevation-0">
      <v-card-title class="pb-0">
        <span v-if="totalImagenes > 1" class="text-caption grey--text">
          {{ indiceActual + 1 }} / {{ totalImagenes }}
        </span>
        <v-spacer></v-spacer>
        <template v-if="!esVideo">
          <v-btn icon small title="Alejar" :disabled="!zoomActivo" @click="zoomOut()">
            <v-icon>mdi-magnify-minus</v-icon>
          </v-btn>
          <v-slider
            v-model="zoomSlider"
            class="zoom-slider mx-1"
            :min="100"
            :max="800"
            :step="10"
            hide-details
            dense
            title="Ajustar zoom"
            @keydown.native.left.stop
            @keydown.native.right.stop
          ></v-slider>
          <v-btn icon small title="Acercar" :disabled="zoomScale >= ZOOM_MAX" @click="zoomIn()">
            <v-icon>mdi-magnify-plus</v-icon>
          </v-btn>
          <span class="text-caption grey--text mx-1 zoom-porcentaje">{{ zoomPorcentaje }}%</span>
          <v-btn icon small title="Descargar" @click="descargarImagenActual">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <v-btn fab small text @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-2 imagen-viewer-wrapper">
        <v-btn
          v-if="puedeAnterior"
          icon
          large
          class="nav-btn nav-btn-left"
          title="Imagen anterior"
          @click="imagenAnterior"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>

        <div
          v-if="!esVideo"
          ref="contenedorZoom"
          class="imagen-contenedor"
          :class="{ 'imagen-contenedor--zoom': zoomActivo }"
          @wheel.prevent="onWheelZoom"
          @mousedown="iniciarArrastre"
        >
          <img
            :src="imagenSrc"
            ref="imagenZoom"
            class="imagen-viewer"
            :class="{ 'imagen-viewer--zoom': zoomActivo }"
            :style="imagenZoomStyle"
            draggable="false"
            @click="onClickImagen"
            @contextmenu.prevent="descargarImagenActual"
          />
        </div>

        <v-btn
          v-if="puedeSiguiente"
          icon
          large
          class="nav-btn nav-btn-right"
          title="Imagen siguiente"
          @click="imagenSiguiente"
        >
          <v-icon large>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text v-if="!esVideo" class="pt-0 text-center text-caption grey--text">
        Clic para acercar 10% en el punto elegido · Mantén el clic y arrastra para mover · Rueda, slider o +/- para zoom · Clic derecho para descargar · Flechas para navegar
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const ZOOM_STEP = 0.1;
const ZOOM_WHEEL_STEP = 0.1;
const ZOOM_MIN = 1;
const ZOOM_MAX = 8;

export default {
  name: 'ImagenIncidencia',
  props: {
    isOpen: Boolean,
    imagen: String,
    imagenes: {
      type: Array,
      default: function () {
        return [];
      },
    },
    indiceInicial: {
      type: Number,
      default: 0,
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      ZOOM_MAX: ZOOM_MAX,
      indiceActual: 0,
      zoomScale: 1,
      panX: 0,
      panY: 0,
      video: false,
      arrastre: {
        activo: false,
        movido: false,
        startX: 0,
        startY: 0,
        panX0: 0,
        panY0: 0,
      },
    };
  },
  computed: {
    listaImagenes: function () {
      if (this.imagenes && this.imagenes.length) return this.imagenes;
      if (this.imagen) return [{ foto: this.imagen }];
      return [];
    },
    itemActual: function () {
      return this.listaImagenes[this.indiceActual] || {};
    },
    imagenActual: function () {
      return this.itemActual.foto || this.imagen || '';
    },
    imagenSrc: function () {
      var base = this.baseUrl || '';
      if (base && base.charAt(base.length - 1) !== '/') base += '/';
      return base + this.imagenActual;
    },
    totalImagenes: function () {
      return this.listaImagenes.length;
    },
    puedeAnterior: function () {
      return this.indiceActual > 0;
    },
    puedeSiguiente: function () {
      return this.indiceActual < this.totalImagenes - 1;
    },
    esVideo: function () {
      return this.video;
    },
    zoomActivo: function () {
      return this.zoomScale > 1.001;
    },
    zoomPorcentaje: function () {
      return Math.round(this.zoomScale * 100);
    },
    zoomSlider: {
      get: function () {
        return Math.round(this.zoomScale * 100);
      },
      set: function (valor) {
        this.aplicarZoom(valor / 100);
      },
    },
    imagenZoomStyle: function () {
      return {
        transform: 'translate(' + this.panX + 'px, ' + this.panY + 'px) scale(' + this.zoomScale + ')',
        transformOrigin: 'center center',
      };
    },
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        this.indiceActual = this.indiceInicial;
        this.resetZoom();
      } else {
        this.resetZoom();
      }
    },
    indiceActual: function () {
      this.resetZoom();
    },
  },
  methods: {
    resetZoom: function () {
      this.zoomScale = 1;
      this.panX = 0;
      this.panY = 0;
    },
    aplicarZoom: function (escalaNueva, e) {
      var cont = this.$refs.contenedorZoom;
      var escalaVieja = this.zoomScale;
      var escala = Math.max(ZOOM_MIN, Math.min(escalaNueva, ZOOM_MAX));
      if (!cont || !e || escala === escalaVieja) {
        this.zoomScale = escala;
        if (escala <= ZOOM_MIN) {
          this.panX = 0;
          this.panY = 0;
        }
        return;
      }
      var rect = cont.getBoundingClientRect();
      var cx = e.clientX - rect.left - rect.width / 2;
      var cy = e.clientY - rect.top - rect.height / 2;
      var ratio = escala / escalaVieja;
      this.panX = cx - (cx - this.panX) * ratio;
      this.panY = cy - (cy - this.panY) * ratio;
      this.zoomScale = escala;
      if (escala <= ZOOM_MIN) {
        this.panX = 0;
        this.panY = 0;
      } else {
        this.limitarPan();
      }
    },
    limitarPan: function () {
      var cont = this.$refs.contenedorZoom;
      var img = this.$refs.imagenZoom;
      if (!cont || !img || this.zoomScale <= 1) {
        this.panX = 0;
        this.panY = 0;
        return;
      }
      var baseW = img.offsetWidth || img.clientWidth || 0;
      var baseH = img.offsetHeight || img.clientHeight || 0;
      var scaledW = baseW * this.zoomScale;
      var scaledH = baseH * this.zoomScale;
      var maxX = Math.max(0, (scaledW - cont.clientWidth) / 2);
      var maxY = Math.max(0, (scaledH - cont.clientHeight) / 2);
      this.panX = Math.max(-maxX, Math.min(maxX, this.panX));
      this.panY = Math.max(-maxY, Math.min(maxY, this.panY));
    },
    toggleZoom: function (e) {
      if (this.zoomScale >= ZOOM_MAX) {
        this.resetZoom();
      } else {
        this.aplicarZoom(this.zoomScale + ZOOM_STEP, e);
      }
    },
    zoomIn: function (punto) {
      if (this.zoomScale < ZOOM_MAX) {
        this.aplicarZoom(this.zoomScale + ZOOM_STEP, punto || this.puntoCentro());
      }
    },
    zoomOut: function (punto) {
      if (this.zoomActivo) {
        this.aplicarZoom(this.zoomScale - ZOOM_STEP, punto || this.puntoCentro());
      }
    },
    puntoCentro: function () {
      var cont = this.$refs.contenedorZoom;
      if (!cont) return null;
      var rect = cont.getBoundingClientRect();
      return {
        clientX: rect.left + rect.width / 2,
        clientY: rect.top + rect.height / 2,
      };
    },
    onWheelZoom: function (e) {
      var punto = { clientX: e.clientX, clientY: e.clientY };
      if (e.deltaY < 0) {
        this.aplicarZoom(this.zoomScale + ZOOM_WHEEL_STEP, punto);
      } else if (this.zoomActivo) {
        this.aplicarZoom(this.zoomScale - ZOOM_WHEEL_STEP, punto);
      }
    },
    iniciarArrastre: function (e) {
      if (!this.zoomActivo || e.button !== 0) return;
      this.arrastre.activo = true;
      this.arrastre.movido = false;
      this.arrastre.startX = e.clientX;
      this.arrastre.startY = e.clientY;
      this.arrastre.panX0 = this.panX;
      this.arrastre.panY0 = this.panY;
      window.addEventListener('mousemove', this.moverArrastre);
      window.addEventListener('mouseup', this.terminarArrastre);
    },
    moverArrastre: function (e) {
      if (!this.arrastre.activo) return;
      var dx = e.clientX - this.arrastre.startX;
      var dy = e.clientY - this.arrastre.startY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) this.arrastre.movido = true;
      this.panX = this.arrastre.panX0 + dx;
      this.panY = this.arrastre.panY0 + dy;
      this.limitarPan();
    },
    terminarArrastre: function () {
      this.arrastre.activo = false;
      window.removeEventListener('mousemove', this.moverArrastre);
      window.removeEventListener('mouseup', this.terminarArrastre);
    },
    onClickImagen: function (e) {
      if (this.arrastre.movido) {
        this.arrastre.movido = false;
        return;
      }
      this.toggleZoom(e);
    },
    imagenAnterior: function () {
      if (this.puedeAnterior) this.indiceActual -= 1;
    },
    imagenSiguiente: function () {
      if (this.puedeSiguiente) this.indiceActual += 1;
    },
    descargarImagenActual: function () {
      var self = this;
      if (!this.imagenActual) return;
      var nombreArchivo = (this.imagenActual || '').split('/').pop() || 'evidencia';
      fetch(this.imagenSrc)
        .then(function (response) {
          if (!response.ok) throw new Error('fail');
          return response.blob();
        })
        .then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = blobUrl;
          link.download = nombreArchivo;
          link.click();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(function () {
          var link = document.createElement('a');
          link.href = self.imagenSrc;
          link.download = nombreArchivo;
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    closeDialog: function () {
      this.$emit('close');
    },
  },
  beforeDestroy: function () {
    window.removeEventListener('mousemove', this.moverArrastre);
    window.removeEventListener('mouseup', this.terminarArrastre);
  },
};
</script>

<style scoped>
.imagen-viewer-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.imagen-contenedor {
  width: 100%;
  height: 80vh;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imagen-contenedor--zoom {
  cursor: grab;
}
.imagen-contenedor--zoom:active {
  cursor: grabbing;
}
.imagen-viewer {
  max-width: 100%;
  max-height: 80vh;
  width: auto;
  height: auto;
  cursor: zoom-in;
  object-fit: contain;
  user-select: none;
  will-change: transform;
}
.imagen-viewer--zoom {
  cursor: inherit;
}
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  background: rgba(255, 255, 255, 0.85) !important;
}
.nav-btn-left {
  left: 4px;
}
.nav-btn-right {
  right: 4px;
}
.zoom-slider {
  max-width: 160px;
  flex: 0 1 160px;
}
.zoom-porcentaje {
  min-width: 42px;
  text-align: right;
}
</style>
